import { Alert, AlertTitle, Snackbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useContextProvider } from "../page-context/ContextProvider";

const SnackbarAlert = () => {
  const { currentAlert, dequeueAlert } = useContextProvider();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (currentAlert) setOpen(true);
  }, [currentAlert?.id]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const getSeverityTitle = (severity) => {
    switch (severity) {
      case "error": return t("Error");
      case "warning": return t("Warning");
      case "info": return t("Information");
      case "success":
      default: return t("Success");
    }
  };

  return (
    <Snackbar
      key={currentAlert?.id}
      open={open}
      autoHideDuration={currentAlert?.duration ?? 3000}
      onClose={handleClose}
      anchorOrigin={currentAlert?.anchorOrigin ?? { vertical: "bottom", horizontal: "right" }}
      slotProps={{
        transition: {
          onExited: () => {
            dequeueAlert();
          },
        },
      }}>
      <Alert
        onClose={handleClose}
        severity={currentAlert?.severity ?? "success"}
        variant="standard"
        sx={{
          minWidth: "320px",
          maxWidth: "450px",
          animation: "org-fadeInRight 0.3s ease",
        }}
        slotProps={{
          closeButton: {
            size: "small",
            sx: { color: "#161616", opacity: 0.6, "&:hover": { opacity: 1 } }
          }
        }}
      >
        <AlertTitle sx={{ fontWeight: 700, mb: 0.5, fontSize: "0.875rem", lineHeight: 1.2 }}>
          {getSeverityTitle(currentAlert?.severity)}
        </AlertTitle>
        <Typography variant="body2" sx={{ fontSize: "0.875rem", lineHeight: 1.4, color: "inherit" }}>
          {t(currentAlert?.message ?? "")}
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
